import { Controller } from '@hotwired/stimulus';

// Drawer/bottom-sheet for editing the BD shipping address inline.
// Posts JSON to the URL passed via the `submit-url` value and updates
// the recap-bar's short-label on success.
export default class extends Controller {
  static targets = ['sheet', 'form', 'error'];
  static values = { submitUrl: String };

  open() {
    this.sheetTarget.hidden = false;
    document.body.classList.add('bd-sheet-open');
  }

  close() {
    this.sheetTarget.hidden = true;
    document.body.classList.remove('bd-sheet-open');
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = true;
      this.errorTarget.textContent = '';
    }
  }

  async save(event) {
    event.preventDefault();
    const form = this.formTarget;
    const data = new FormData(form);
    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const csrf = csrfMeta ? csrfMeta.content : '';

    const url = this.submitUrlValue || '/subscriptions/bd/monthly/address';
    const response = await fetch(url, {
      method: 'POST',
      body: data,
      headers: { 'X-CSRF-Token': csrf || '', Accept: 'application/json' }
    });

    let json;
    try {
      json = await response.json();
    } catch (_e) {
      json = {};
    }

    if (response.ok) {
      const short = document.querySelector(
        "[data-bd-monthly-selection-target='addressShort']"
      );
      if (short && json.short_label) short.textContent = json.short_label;
      this.close();
    } else if (this.hasErrorTarget) {
      this.errorTarget.textContent = (json.errors || ['Erreur inattendue']).join(' · ');
      this.errorTarget.hidden = false;
    }
  }
}
